<template>
  <div class="page-msisdn" v-if="showLogin">
    <img src="../../../img/identity/p4f.svg" alt="pocket4fun" style="margin: 20px"><br>
    <h2 class="only-en">Subscribe to Pocket4Fun</h2><br>
    <div class="container">
      <h3 class="only-en" v-if="!pin">Enter your mobile number</h3>
      <h3 class="only-en" v-else>Enter your PIN</h3><br>
      <form @submit.prevent="login(slug)" class="gutter-xs q-pa-xs" @keydown="form.onKeydown($event)">
        <!-- Msisdn -->
        <div class="flex" style="justify-content: center; flex-wrap: inherit;">
          <img src="../../../img/telemovel.png" width="40px" height="40px" style="margin-right: -42px;
                                          position: relative;
                                          margin-top: 9px" />
          <v-input v-if="!pin" path="msisdn" v-model="form.msisdn" placeholder="47XXXXXXXX" type="text" color="highlight"
            class="input-login" :form="form">
          </v-input>
          <v-input v-else path="msisdn"
                  ref="pin"
                  v-model="form.pin"
                  type="text"
                  placeholder="PIN"
                  :form="form"
                  class="input-login"
          >
          </v-input>
        </div>
        <br>

        <!-- Submit Button -->
        <div class="row justify-center">
          <v-submit style="font-weight: bold; padding: 14px 49px;" :label="$t('SUBSCRIBE NOW')"
            :loadingLabel="$t('validating...')" color="primary" :form="form">
          </v-submit>
        </div><br>
        <q-btn class="btn btn-danger" @click="exit()">EXIT</q-btn>
        <br>
      </form>
      <br>
      <div id="disclaimer" class="only-en">
        <span class="bullets-en">
          <br>Welcome to Pocket4Fun.
          <br> Enjoy your Free trial for where you can pick and choose several contents, such as Football News, Games, Music, Videos and much more.
        </span>
      </div>
    </div><br><br>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Form from 'vform'
import { QModal, QSpinnerPuff, QBtn, QCheckbox, QInput, Cookies } from 'quasar-framework'
import VInput from "../../components/form/VInput";

export default {
  components: {
    VInput,
    QModal,
    QBtn,
    QSpinnerPuff,
    QCheckbox,
    QInput,
  },
  computed: {
      ...mapGetters({
          user: 'auth/user',
          settings: 'local/settings'
      }),
      showLogin: {
          get() {
              return this.settings('msisdn')
          },
          set(value) {
              this.$store.dispatch('local/set', {key: 'msisdn', value})
          }
      },
      slug: {
          get() {
              return this.settings('redirect-route')
          },
          set(value) {
              this.$store.dispatch('local/set', {key: 'redirect-route', value})
          }
      },
  },
  data: () => ({
    form: new Form({
      msisdn: '',
      redirectTo: this.slug,
      pin: ''
    }),
    pin: false,
    redirect: '',
    portal_base: null,
    query: '',
    service: ''
  }),

  methods: {
    exit() {
      this.form = new Form({
        msisdn: '',
        redirectTo: this.slug,
        pin: ''
      });
      this.pin = false;
      this.showLogin = false;
      this.$router.back();
    },
    async login(slug) {
      if (!this.form.msisdn) {
          this.$q.notify({
            color: 'red',
            icon: 'warning',
            message: this.$T('Please, inform phone number'),
            detail: "",
            position: 'top'
          })
          return
      }
      if (this.pin && !this.form.pin) {
        this.$q.notify({
          color: 'red',
          icon: 'warning',
          message: this.$T('Please, inform PIN'),
          detail: "",
          position: 'top'
        })
      } else if (this.form.pin) {
        this.form.redirectTo = (slug != undefined) ? slug : "/";
        this.form.portal = Cookies.get('portal');
        this.form.msisdn = '351963852741';

        // Submit the form.
        const { data } = await this.form.post(`${config.SkySMSUrl}/login`)
        window.location.href = data;
      }
      this.pin = true;
    }
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Open+Sans:600');

.page-msisdn {
  text-align: center;
  max-width: 100%;
  background-image: url("/img/cellphone.jpg");
  background-size: 3000px;
  background-position: fixed;
  background-repeat: repeat;
  color: #000000;
  font-size: 14px;
  padding-bottom: 400px;
  max-height: 100vh;
}

.input-login {
  display: flex;
  padding-right: 16px;
  text-align-last: center;
  border-radius: 10px;
  height: 55px;
  align-items: center;
  background-color: white;
  font-size: 18px;
  padding-left: 45px;
}

.btn-danger {
  background-color: #ffffff;
  border: 1px solid #ea3e32;
  color: #ea3e32;
}

.only-en {
  display: block;
  margin-top: 20px;
  color: #000;
}

.bullets-en {
  display: block;
  text-align: left;
}

ol li a {
  text-decoration: underline;
  color: #000 !important;
}

li a {
  text-decoration: underline;
  color: #000 !important;
}

ul {
  list-style-type: none;
  text-align: left;
}

img {
  max-width: 300px;
}

.container {
  background-color: rgb(255, 210, 210, 0.7);
  width: 50%;
  margin: 0 auto;
  padding: 30px;
  font-weight: bold;
  -webkit-transition: box-shadow 0.5s;
  transition: box-shadow 0.5s;
  overflow: hidden;
  border-radius: 10px;
}

@media only screen and (max-width: 800px) {
  .container {
    width: 80%;
  }
  img {
    max-width: 270px;
  }
  .page-msisdn {
    max-height: 110vh;
  }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/auth/msisdn.vue